import React from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { ToolMode } from '~admin/store/create-edit-event-flow-store';
import { CreateEditEventFlowStoreProvider } from '~admin/store/create-edit-event-flow-store-provider';
import { EditEvent } from '~admin/view/components/edit-event/edit-event.component';
import { EditEventPageParameters } from '~admin/view/pages/parameters';
import { Column } from '~common/components/column.component';
import { ScrollBar } from '~web/view/theme/utils';

export const EditEventPage: React.FunctionComponent = () => {
  const { eventId } = useParams<EditEventPageParameters>();

  return (
    <Container>
      <CreateEditEventFlowStoreProvider mode={ToolMode.EDIT}>
        <EditEvent eventId={eventId} />
      </CreateEditEventFlowStoreProvider>
    </Container>
  );
};

const Container = styled(Column)`
  width: 100%;
  height: 100%;
  align-items: center;
  ${ScrollBar};
`;



// WEBPACK FOOTER //
// ./view/pages/edit-event.page.tsx